'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesStartLabel: {
            type: String,
            kComposite: 'messages.startLabel'
        },
        messagesEndLabel: {
            type: String,
            kComposite: 'messages.endLabel'
        }
    }
};